"use strict";

import YouTubePlayer from "youtube-player";
import throttle from "lodash/throttle";

export default class YoutubeVideo {
    constructor(el) {
      this.el = el;
  
      // https://github.com/feross/yt-player
      this.player = new YouTubePlayer(el, {
        modestBranding: true,
      });
  
      this.parent = el.parentNode;
      this.player.cueVideoById(this.el.dataset.id);
      // this.player.stopVideo();
    }
  
    add_tracking() {
      this.player.on("playing", () => {});
    }
  
    pin_height() {
      const compute = () => {
        this.player.getIframe().then((iframe) => {
          const $el = iframe;
          const r = $el.clientHeight / this.parent.clientHeight;
          this.player.setSize($el.clientWidth / r, this.parent.clientHeight);
        });
      };
      this.player.addEventListener("onStateChange", () => {
        compute();
        window.addEventListener("resize", throttle(compute, 100));
      });
    }
  
    pin_width() {
      const compute = () => {
        this.player.getIframe().then((iframe) => {
          const $el = iframe;
          const r = $el.clientWidth / this.parent.clientWidth;
          this.player.setSize(this.parent.clientWidth, $el.clientHeight / r);
        });
      };
      this.player.addEventListener("onStateChange", () => {
        compute();
        window.addEventListener("resize", throttle(compute, 100));
      });
    }
}
